import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {FormsModule} from '@angular/forms';
import {LeaderboardPage} from './leaderboard-page/leaderboard.page';
import {ComponentsModule} from '../components/components.module';
import {TranslateModule} from '@ngx-translate/core';
import {SkeletonLeaderboardComponent} from './skeleton/skeleton-leaderboard.component';
import {VideoChatModule} from '../video-chat/video-chat.module';
import {LeaderboardRoutingModule} from './leaderboard-routing.module';
import {LeaderboardWorldPage} from './leaderboard-world-page/leaderboard-world.page';
import {LeaderboardHubPage} from './leaderboard-hub-page/leaderboard-hub.page';
import {LeaderboardShoosmithsPage} from './leaderboard-shoosmiths-page/leaderboard-shoosmiths.page';
import {PipesModule} from '../../pipes/pipes.module';
import {LeaderboardVeeamPage} from './leaderboard-veeam/leaderboard-veeam.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule.forChild(),
    LeaderboardRoutingModule,
    ComponentsModule,
    VideoChatModule,
    PipesModule,
  ],
  declarations: [
    LeaderboardPage,
    LeaderboardWorldPage,
    LeaderboardHubPage,
    LeaderboardShoosmithsPage,
    LeaderboardVeeamPage,
    SkeletonLeaderboardComponent]
})
export class LeaderboardModule {
}
